import React from "react";

import { RecentForm } from "@data-types/sport-stats/SportStatsTypes";

export const EventWinLostDrawStats = ({
	form,
}: {
	form: RecentForm[] | null;
}) => {
	if (form) {
		return (
			<div className="stats--scores">
				{form.map((stats, i) => {
					return <StatsItem key={i} stats={stats} />;
				})}
			</div>
		);
	} else {
		return null;
	}
};

const StatsItem = ({ stats }: { stats: RecentForm }) => {
	let statsType = "";

	switch (stats) {
		case "W":
			statsType = "win";
			break;
		case "L":
			statsType = "lose";
			break;
		case "D":
			statsType = "draw";
			break;
		default:
			break;
	}

	return (
		<div className={`stats--scores__box stats--scores__box--${statsType}`}>
			{stats}
		</div>
	);
};
